/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'confluence-analytics-chart.default-loading-text': 'Päivitetään analytiikkatietoja...',
  'confluence-analytics-chart.tooltip.no-views-data': 'Ei tietoja',
  'confluence-analytics-chart.tooltip.views-overall':
    '{count, plural, one {1 katselukerta} other {{count} katselukertaa}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 katselukerta toistaiseksi} other {{count} katselukertaa toistaiseksi}}',
  'confuence-analytics-chart.accessible-table.caption': 'Sivun katselukertoja',
  'confuence-analytics-chart.accessible-table.header.date': 'Päivämäärä',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Katselukerrat',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Ei katselukertoja',
};
